var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAskNeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.10573,
    y: 0.773938,
    width: 19.2613,
    height: 19.2613,
    rx: 6.56635,
    stroke: "black",
    strokeWidth: 0.875513
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9738 9.89107C12.9687 9.04088 12.0191 8.13128 11.1689 6.1684C10.8462 5.37056 10.5742 5.10332 10.1866 6.05588C9.33876 8.08595 8.3268 9.05338 6.33412 9.89117C6.13407 9.98338 5.77382 10.1436 5.77148 10.3335C5.77383 10.5233 6.13173 10.6835 6.33412 10.7757C8.32442 11.6111 9.33882 12.5808 10.1866 14.611C10.5789 15.5808 10.8516 15.276 11.1689 14.4985C12.0191 12.5363 12.9685 11.626 14.9738 10.7758C15.184 10.6758 15.5309 10.543 15.5661 10.3437V10.321C15.5309 10.1233 15.1863 9.98892 14.9738 9.8889V9.89107Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskNeo);
export default __webpack_public_path__ + "static/media/AskNeo.99ec8d89475e756bec9e473aa8fabd56.svg";
export { ForwardRef as ReactComponent };